import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { KEY_CODES } from 'resources/constants'
import { ReactComponent as SearchSvg } from 'resources/svg/icons/search.svg'
import { Container } from './components/Styled'

export const Search = () => {
  const history = useHistory()
  const [search, setSearch] = useState('')

  const handleSearch = () => {
    const url = `/search/${encodeURIComponent(search)}`
    history.push(url)
  }

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if ((e.keyCode || e.which) === KEY_CODES.ENTER) {
      handleSearch()
    }
  }

  return (
    <Container>
      <input
        type='search'
        placeholder='Looking for something?'
        onKeyPress={handleKeyPress}
        onChange={e => setSearch(e.target.value)}
      />
      <button onClick={handleSearch} type='button'>
        <SearchSvg />
      </button>
    </Container>
  )
}
